import { event as gaEvent } from 'react-ga';

export const gaEventActions = {
	__setGAEvent: ({ referralID }, category, action) => {
		gaEvent({
			category,
			label: `${referralID}` || 'Anony-Mouse',
			action,
			value: parseInt(new Date().getTime() / 1000),
		});
	},
};
